import PasswordValidator from 'password-validator';

export const PASSWORD_MIN_LENGTH = 14;

const validator = new PasswordValidator();
validator.is().min(PASSWORD_MIN_LENGTH).has().uppercase().has().lowercase().has().digits(2).has().symbols();

export function getPasswordRequirements(password: string) {
    const missing = validator.validate(password, { list: true }) as string[];

    return {
        hasMinLength: !missing.includes('min'),
        hasDigits: !missing.includes('digits'),
        hasUppercase: !missing.includes('uppercase'),
        hasLowercase: !missing.includes('lowercase'),
        hasSymbols: !missing.includes('symbols'),
        isValid: missing.length === 0,
    };
}
